export const setSeekInterval = function (callback, intervalTime) {
  console.log('Playerinterval setSeekInterval');
  const seekInterval = {
    interval: intervalTime * 1000,
    callback: callback,
    stopped: false,
    timeout: null,
    initBucle: function () {
      //Do a stopped state
      if (seekInterval.stopped) {
        console.log('[NPC] Playerinterval setSeekInterval initBucle en stop (ready to track next seek)');
        return;
      }
      console.log('[NPC] Playerinterval setSeekInterval initBucle');
      let result;
      result = seekInterval.callback.call(seekInterval);
      console.log('[NPC] Playerinterval setSeekInterval initBucle tiene result: ' + result);
      if (typeof result == 'number') {
        if (result === 0) {
          return;
        }
        seekInterval.interval = result;
      }
      // After do a seek, reinit loop (bucle method) to get next state: stopped state (above)
      seekInterval.bucle();
    },
    stop: function () {
      console.log('[NPC] Playerinterval setSeekInterval stop');
      this.stopped = true;
      clearTimeout(this.timeout);
    },
    start: function () {
      console.log('[NPC] Playerinterval setSeekInterval start');
      this.stopped = false;
      return this.bucle();
    },
    bucle: function () {
      console.log('[NPC] Playerinterval setSeekInterval bucle ' + this.interval);
      this.timeout && clearTimeout(this.timeout);
      this.timeout = setTimeout(this.initBucle, this.interval);
      return this;
    }
  };

  return seekInterval.start();
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/seekIntervalUtil.js